<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<div class="row">
  <div class="col-md-1 col-adjust">
    <span class="initials-bubble">{{ currentUser!.initials }}</span>
    <!-- @if(hasUser()){
    } -->
  </div>
  <div class="col">
    <div class="row">
      <div class="col-4">
        <span class="fullname-header">&#64;{{ currentUser!.fullName }}</span>
      </div>
      <div class="col" style="text-align: end;">
        @if(isLoggedInUser()) {
        <kendo-dropdownbutton [data]="data" [svgIcon]="verticalIcon" (itemClick)="onButtonClicked($event)">
          <ng-template kendoDropDownButtonItemTemplate let-dataItem>
            <kendo-svgicon [icon]="dataItem.svgIcon"></kendo-svgicon>
            <span>{{ dataItem.text }}</span>
          </ng-template>
        </kendo-dropdownbutton>
        }
      </div>
    </div>
    <div>
      <!-- {{activity.description}} -->
      @if(!readonlyFlag) {
      <form #ngF="ngForm" class="k-form-inline" [formGroup]="form">
        <div #kEditor>
          <kendo-editor class="flex-fill" formControlName="comment" [readonly]="readonlyFlag">
          </kendo-editor>
        </div>
        <div class="d-grid d-md-flex mt-2 justify-content-md-end">
          <button type="button" class="btn btn-outline-secondary btn-sm me-md-2" (click)="cancelChanges()">Cancel
          </button>
          <button type="button" class="btn btn-primary btn-sm me-md-2" (click)="saveChanges()"
            [disabled]="form.invalid">Update
          </button>
        </div>

      </form>
      } @else {
      <div #hiddenComment [innerHTML]="currentComment.comment"></div>
      }
    </div>
     <!-- <div class="row">
        <div class="col">
          <div class="footer-wrapper">
            <casi-emoji-content [emojiInput]="selectedEmoji" (onSave)="setEmoji($event)"></casi-emoji-content>
            {{currentComment.createdAt | date}}
          </div>
        </div>
      </div> -->
    </div>

  </div>
